<template>
    <div class="row mb-3">
        <label :class="'col-form-label col-sm-' + labelCols" :for="field.id"> {{ field.label }}{{
                field.required ? '*' : ''
            }} </label>
        <div :class="'col-' + fieldCols">
            <input :id="field.id" :disabled="field.locked" :accept="fileTypes" class="form-control" type="file" v-bind:required="field.required"
                   v-on:input="changeValue">
            <div class="form-text">({{ fileTypesPretty }})</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            required: false,
            defaultValue: ''
        },
        fieldCols: {
            type: String,
            required: true
        },
        labelCols: {
            type: String,
            required: true
        }
    },
    computed: {
        fileTypesPretty() {
            if (this.field !== undefined) {
                let data = JSON.parse(this.field.data);
                let allowedTypes = data.fileTypes;
                return allowedTypes.join(', ');
            }
            return '';
        },
        fileTypes() {
            if (this.field !== undefined) {
                let data = JSON.parse(this.field.data);
                let allowedTypes = data.fileTypes;
                return allowedTypes.join(',');
            }
            return '';
        }
    },
    methods: {
        changeValue(event) {
            let filePathSplit = event.target.value.split('\\');
            let returnValue = {
                files: event.target.files,
                value: `{\"key\":\"\",\"value\":\"${filePathSplit[filePathSplit.length - 1]}\"}`
            };
            this.$emit('update:modelValue', returnValue);
        }
    }
}
</script>